import { SVGProps, FC } from 'react'

import * as svg from '@uikit/svg'
import * as icons from '@uikit/svg/social-media'
import * as payments from '@uikit/svg/payments'
const avgIcons = { ...icons, ...svg, ...payments }
type A = keyof typeof avgIcons
export type IconNames = A extends `Svg${infer Icon}` ? Icon : never

export type IconProps = SVGProps<SVGSVGElement> & {
  iconName: IconNames | undefined | null
}

export const Icon: FC<IconProps> = ({ iconName, ...rest }) => {
  if (!iconName) {
    return null
  }

  /*eslint import/namespace: ['error', { allowComputed: true }]*/
  const Component = avgIcons[`Svg${iconName}`]
  return <Component {...rest} />
}
